/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-01-04 18:54:05
 */
import React, { useEffect } from 'react'
import { Modal, Progress } from 'antd'
import sensors from '../../../../utils/sensors'
import { useFileNums } from '../hooks'
import { useAppSelector, useSensorsRole } from '../../../../app/hooks'

const ProgressDialog = ({ fileList, percent, onClose }) => {
  const { photosNum, videosNum } = useFileNums(fileList)
  const groupID = useAppSelector((state) => state.group.groupId)
  const role = useSensorsRole()

  const sensorsEvent = (actionType) => {
    sensors.track('web_get_action_bigbatch_upload_process', {
      actionType,
      photoNum: photosNum,
      videoNum: videosNum,
      groupID,
      role
    })
  }

  const handleModalClose = () => {
    sensorsEvent('clickClose')
    onClose()
  }

  const handleProcessCancel = () => {
    sensorsEvent('clickCancel')
    onClose()
  }

  useEffect(() => {
    if (photosNum || videosNum) {
      sensorsEvent('showPop')
    }
  }, [photosNum, videosNum])

  return (
    <Modal
      open
      getContainer={false}
      wrapClassName="progress-modal"
      width={780}
      style={{ height: '540px' }}
      mask={{ closable: false }}
      footer={null}
      onCancel={handleModalClose}
    >
      <h3>
        正在上传：{photosNum}张照片、{videosNum}个视频
      </h3>
      <div className="progress-container">
        <Progress
          type="circle"
          width={180}
          strokeWidth={8}
          strokeColor={{
            '14%': '#FFAD4A',
            '56%': '#686EFE',
            '88%': '#4CA3FF'
          }}
          trailColor="#d9e2ff"
          percent={percent}
          format={(percent) => {
            return (
              <div className="progress-content">
                <span className="progress-num">{percent}%</span>
                <span className="progress-text">已上传</span>
              </div>
            )
          }}
        />
      </div>
      <button className="cancel-btn" onClick={handleProcessCancel}>
        取消上传
      </button>
      <p className="tip">上传途中请勿关闭弹窗</p>
    </Modal>
  )
}

export default ProgressDialog
